export default __webpack_public_path__ + "static/DesktopMediaMainBanner-36b670302efa8ff81335c143cad277b3.png";